import { Output, Component, Input, EventEmitter, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";
import { iconsLibrary } from "../../../../theme/constants";

@Component({
  selector: "cowing-essential-service",
  templateUrl: "./cowing-essential-service.component.html",
  styleUrls: ["./cowing-essential-service.component.scss"],
})
export class CowingEssentialServiceComponent {
  @Input("label") label: string = "";
  @Input("icon_url") icon_url: string = "";
  @Input("isForm") isForm: boolean = false;
  @Input("control") control: FormControl = null;

  @Output("event") onClickEvent = new EventEmitter();

  onClick(event) {
    this.onClickEvent.emit(event);
  }

  public changeValue() {
    this.control.setValue(!this.control.value);
    this.control.updateValueAndValidity();
  }
}
